/* eslint-disable angular/window-service */
/* eslint-disable angular/timeout-service */
/* eslint-disable angular/document-service */
angular.module('tgaAdmin')
  .controller('InstructorAnalyticsController', [
    '$scope', '$state', '$location', '$filter', '$timeout', '$window', 'gameService', 'reportService',
    'instructorService', 'questionListService', 'userService', '$sce', 'settingsService',
    'modalService', 'game', 'tzService', '$log',
    function (
      $scope, $state, $location, $filter, $timeout, $window, gameService, reportService,
      instructorService, questionListService, userService, $sce, settingsService,
      modalService, game, tzService, $log,
    ) {
      $scope.showBack = true;

      $scope.data = {
        gameId: $state.params.game_id || null,
        sessionGroupId: $state.params.session_group_id || null,
        yesno: [
          {
            id: 'virtual',
            name: 'Virtual',
          },
          {
            id: 'live',
            name: 'In-Person',
          },
        ],
        tableStateParams: null,
      };

      $scope.viewmodel = {
        slug: null,
        name: null,
        game,
        session_group: {},
        history: {
          session_group_id: null,
          players: [],
          questions: [],
          questionAnswers: {},
        },
      };

      $scope.initialize = function () {
        $scope.historyLoading = true;

        if ($scope.viewmodel.game.game_mode === 'standard') {
          $window.history.back();
          return;
        }

        instructorService.getSessionGroup($scope.data.gameId, $scope.data.sessionGroupId).then((session_group) => {
          $scope.viewmodel.session_group = session_group;
          // eslint-disable-next-line max-len
          $scope.title = `<span class="text-muted">Instructor / ${game.name} / Sessions / </span> ${session_group.name || session_group.slug}`;
        });

        $scope.data.gameType = $scope.viewmodel.game.game_type;

        if ($scope.data.gameType === 'wbs' || $scope.data.gameType === 'flash') {
          $scope.actions.loadSession();
        }

        if ($scope.data.gameType === 'wbs') {
          $scope.viewmodel.WBS = $scope.actions.processWBSGameMeta($scope.viewmodel.game.meta);
          $scope.viewmodel.WBS.history = $scope.actions.processWBSGameMeta($scope.viewmodel.game.meta);
        }

        settingsService.getSettings().then((settings) => {
          $scope.data.settings = settings;
        });
      };

      $scope.actions = {
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },

        loadPlayers() {
          instructorService.getPlayers({ session_group_id: $scope.data.sessionGroupId }).then((players) => {
            players = players.filter((p) => p.high_score !== null);

            $scope.viewmodel.history.players = _.values(_.merge(
              _.keyBy($scope.viewmodel.history.players, 'user_id'),
              _.keyBy(players, 'user_id'),
            ));

            if ($scope.data.gameType === 'wbs') {
              $scope.actions.formatWBS($scope.viewmodel.WBS.history, $scope.viewmodel.history.players);
            } else {
              $scope.actions.formatQuestions($scope.viewmodel.history.players, $scope.viewmodel.history.questions);
            }
          });
        },

        loadSession(tableState) {
          $scope.historyLoading = true;

          let params = {
            session_group_id: $scope.data.sessionGroupId,
          };

          params = tableState ? {
            ...params,
            paginate: true,
            page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
            limit: tableState.pagination.number,
            sort: tableState.sort.predicate,
            // order: !tableState.sort.reverse ? 'asc' : 'desc',
          } : { ...params, paginate: false };

          // Save tableState params locally for passing to additinonal calls from the controller that need to know where we are in the set
          $scope.data.tableStateParams = params;

          if ($scope.data.gameType === 'wbs') {
            instructorService.getPlayers(params).then((response) => {
              $scope.viewmodel.history.players = response.filter((p) => p.high_score !== null);
              $scope.actions.formatWBS($scope.viewmodel.WBS.history, $scope.viewmodel.history.players);
              $scope.historyLoading = false;
            });
          } else if ($scope.data.gameType === 'flash') {
            instructorService.getPlayers(params).then((response) => {
              $scope.viewmodel.history.players = response.filter((p) => p.high_score !== null);
              $scope.actions.formatQuestions($scope.viewmodel.history.players, $scope.viewmodel.history.questions);
              $scope.historyLoading = false;
            });
          } else if ($scope.viewmodel.history.questions.length === 0) {
            gameService.getQuestions($scope.data.gameId, { language_id: $scope.viewmodel.game.language_id }).then((response) => {
              $scope.viewmodel.history.questions = response.reverse();
              $scope.viewmodel.history.questions.forEach((question) => {
                $scope.viewmodel.history.questionAnswers[question.question_id] = {
                  data: [],
                  isLoading: false,
                  isCollapsed: true,
                };
              });
              $scope.actions.getPlayersAndFilterHistoryQuestions(params, tableState);
            });
          } else {
            $scope.actions.getPlayersAndFilterHistoryQuestions(params, tableState);
          }
        },

        getPlayersAndFilterHistoryQuestions(params, tableState) {
          instructorService.getPlayers(params).then((response) => {
            const players = response.items || response; // .filter((p) => p.high_score !== null);

            const answeredQuestions = [];
            for (let n = 0; n < players.length; n++) {
              const { questions } = players[n];
              let totalTime = 0;
              if (questions.length) {
                for (let i = 0; i < questions.length; i++) {
                  answeredQuestions.push(questions[i].question_id);
                  totalTime += questions[i].time;
                }
              }
              players[n].totalResponseTime = totalTime;
            }
            $scope.viewmodel.history.players = players;

            if (tableState && response.total) {
              tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = response.total;
            }

            const filteredQ = $scope.viewmodel.history.questions.filter((q) => answeredQuestions.includes(q.question_id));
            $scope.viewmodel.history.questions = filteredQ;
            $scope.historyLoading = false;
          });
        },

        loadQuestionAnswers(questionId) {
          if (!$scope.viewmodel.history.questionAnswers[questionId]) {
            $scope.viewmodel.history.questionAnswers[questionId] = {
              data: [],
              isLoading: true,
              isCollapsed: true,
            };
          }

          if ($scope.viewmodel.history.questionAnswers[questionId].data.length === 0) {
            $scope.viewmodel.history.questionAnswers[questionId].isLoading = true;
            instructorService
              .getSessionGroupQuestionPlayerAnswers($scope.data.sessionGroupId, questionId)
              .then((response) => {
                $scope.viewmodel.history.questionAnswers[questionId].data = response.data;
                $scope.viewmodel.history.questionAnswers[questionId].isLoading = false;
              });
          }

          $scope.viewmodel.history.questionAnswers[questionId].isCollapsed = !$scope
            .viewmodel.history.questionAnswers[questionId].isCollapsed;
        },

        override(question) {
          const questionId = question.user_answer_id || question.answers[0].user_answer_id;
          instructorService.overrideAnswer(questionId, question.correct).then(() => {
            if (question.question_list_question_id && question.correct) {
              $scope.actions.updateQuestionList(question);
            }
          });
        },

        updateQuestionList(question) {
          modalService.showModal({
            title: 'Update Question List',
            // eslint-disable-next-line max-len
            message: 'Do you want to update the Intelligent Response Analysis in the corresponding Question List and the Tests using that Question List with the newly acceptable response?',
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            questionListService.addAnswer(question).then(() => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> Question list updated.', 'success');
            }).catch((error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            });
          }).catch(angular.noop);
        },

        formatQuestions(players, questions) {
          if (players.length === 0) {
            questions = [];
          }

          // Loop through each player and create a questions array to display real-time question data.
          players.forEach((player) => {
            // Loop through each question in the player array.
            player.questions.forEach((question) => {
              // Check to see if a question answered by a player is in the questions array.
              let index = questions.map((q) => q.question_id).indexOf(question.question_id);

              // Add the question to the array if it's not there.
              if (index < 0) {
                const questionObject = {
                  question_id: question.question_id,
                  question_type: question.question_type,
                  text: question.text,
                  players: [],
                  isOpen: true,
                };

                questions.unshift(questionObject);

                index = 0;

                questions.forEach((q, i) => {
                  if (i > 0) {
                    q.isOpen = false;
                  }
                });
              }

              const storedQuestion = questions[index];

              // Check to see if the player object is in the stored questions
              const storedPlayerIndex = storedQuestion.players.map((p) => p.user_id).indexOf(player.user_id);

              const playerObject = {
                user_id: player.user_id,
                username: player.username,
                display_name: player.display_name,
                question_list_question_id: question.question_list_question_id,
                correct: question.correct,
                answers: question.answers,
                time: question.time,
                original_correct: question.original_correct,
                date_updated: tzService.parseFormatUserDate(question.date_updated, 'YYYY-MM-DD HH:mm:ss'),
                updated_by: question.updated_by,
              };

              // Add the player object if it's not there
              if (storedPlayerIndex < 0) {
                storedQuestion.players.push(playerObject);
                $scope.viewmodel.currentPlayersAnswered = storedQuestion.players.length;
              } else {
                storedQuestion.players[storedPlayerIndex] = playerObject;
              }
            });
          });
        },

        formatWBS(tables, players) {
          // Populate session data into WBS tables
          const gameMeta = $scope.viewmodel.game.meta;
          const scoreTables = tables.scoreLabels;
          const choicesTable = tables.choiceLabels;

          // Reset sessions' values from score & choices tables
          Object.keys(scoreTables).forEach((round) => {
            Object.keys(scoreTables[round]).forEach((label) => {
              scoreTables[round][label].sessions = [];
            });
          });

          Object.keys(choicesTable).forEach((label) => {
            choicesTable[label].sessions = [];
          });

          players.forEach((player) => {
            // Populate score tables with session scores
            for (let i = 0; i < gameMeta.A_Rounds; i++) {
              scoreTables[`round${i + 1}`].teamName.sessions.push(player.organization);
              const teamId = player.employee_id ? player.employee_id : player.email;
              scoreTables[`round${i + 1}`].teamId.sessions.push(teamId);
              const roundScore = player.session.data[`Round ${i + 1}`];

              const meters = angular.isArray(gameMeta.Meters) ? gameMeta.Meters : Object.keys(gameMeta.Meters);
              for (let m = 0; m < meters.length; m++) {
                const meter = meters[m];
                let meterScore;
                // eslint-disable-next-line no-cond-assign
                if (roundScore && (meterScore = player.session.data[`Round ${i + 1}`][meter])) {
                  scoreTables[`round${i + 1}`][meter].sessions.push(meterScore);
                } else {
                  scoreTables[`round${i + 1}`][meter].sessions.push(' ');
                }
              }
            }
            // Populate choices table with session choices
            Object.keys(choicesTable).forEach((label) => {
              if (label.indexOf('_teamName') > 0) {
                choicesTable[label].sessions.push(player.organization);
              } else if (label.indexOf('_teamId') > 0) {
                const teamId = player.employee_id ? player.employee_id : player.email;
                choicesTable[label].sessions.push(teamId);
              } else if (player.session.data[label]) {
                choicesTable[label].sessions.push(player.session.data[label]);
              } else {
                choicesTable[label].sessions.push(' ');
              }
            });
          });
        },
        processWBSGameMeta(gameMeta) {
          // Team header labels
          const scoreLabels = {};
          const choiceLabels = {};

          // Subdivide score based on number of action choice rounds
          for (let i = 0; i < gameMeta.A_Rounds; i++) {
            scoreLabels[`round${i + 1}`] = {};
            scoreLabels[`round${i + 1}`].teamName = { labels: [`Round ${i + 1}`], sessions: [] };
            scoreLabels[`round${i + 1}`].teamId = { labels: ['&nbsp;'], sessions: [] };

            const meters = angular.isArray(gameMeta.Meters) ? gameMeta.Meters : Object.keys(gameMeta.Meters);
            for (let m = 0; m < meters.length; m++) {
              const meter = meters[m];
              scoreLabels[`round${i + 1}`][meter] = { labels: [meter], sessions: [] };
            }
          }

          // Read the game meta to determine the structure of the Choices section
          choiceLabels.A_teamName = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
          choiceLabels.A_teamId = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
          for (let i = 0; i < gameMeta.Actions.length; i++) {
            choiceLabels[`A${i + 1}`] = { labels: [`A${i + 1}`, gameMeta.A_Labels[i]], sessions: [] }; // S# + friendly label
          }

          // Arbitrary spacing between actions and scenarios to line up with destination worksheet
          const numSpaces = 4;
          for (let i = 0; i < numSpaces; i++) {
            choiceLabels[`Spacer${i}`] = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
          }

          for (let i = 0; i < gameMeta.S_Scores.length; i++) {
            // Provide spacing and labels for each scenario
            choiceLabels[`S${i + 1}_teamName`] = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
            choiceLabels[`S${i + 1}_teamId`] = { labels: [`S${i + 1}`, gameMeta.S_Labels[i]], sessions: [] }; // S# + friendly label

            // Populate each letter in column 2
            Object.keys(gameMeta.S_Scores[i]).forEach((letter) => {
              choiceLabels[`S${i + 1}${letter}`] = { labels: ['', letter], sessions: [] }; // Blank + letter
            });
          }

          return { choiceLabels, scoreLabels };
        },
        exportReport() {
          if (!$scope.viewmodel.history.players.length) {
            return false;
          }

          $scope.exporting = true;

          return instructorService.getPlayers({ session_group_id: $scope.data.sessionGroupId }).then((players) => {
            players = players.filter((p) => p.high_score !== null);
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'The Training Arcade';

            /// /////////////
            // Players
            let worksheet = workbook.addWorksheet('Players');

            worksheet.columns = [
              { header: 'Player', key: 'player', width: 12 },
              { header: 'Score', key: 'score', width: 12 },
            ];

            players.forEach((player) => {
              const rowData = {
                player: player.display_name,
                score: player.high_score,
              };

              worksheet.addRow(rowData);
            });

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [
              { state: 'frozen', ySplit: 1 },
            ];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            /// /////////////
            // Questions
            worksheet = workbook.addWorksheet('Sessions');

            // add column headers
            worksheet.columns = [
              { header: 'Question', key: 'question', width: 12 },
              { header: 'Player', key: 'player', width: 12 },
              { header: 'Correct', key: 'correct', width: 12 },
              { header: 'Answer', key: 'answer', width: 12 },
              { header: 'Answer Duration', key: 'duration', width: 12 },
            ];

            const totalQuestions = $scope.viewmodel.history.questions.length;

            $scope.viewmodel.history.questions.forEach((question, index) => {
              players.forEach((player) => {
                player.questions.forEach((playerQuestion) => {
                  if (playerQuestion.question_id === question.question_id) {
                    const duration = $filter('formatDuration')(playerQuestion.time).split(':');

                    worksheet.addRow({
                      question: `${(totalQuestions - index)}. ${$filter('questionText')(question)}`,
                      player: player.display_name,
                      correct: playerQuestion.correct ? 'Correct' : 'Incorrect',
                      answer: playerQuestion.answers[0].text,
                      duration: {
                        formula: `TIME(${duration[0]},${duration[1]},${duration[2]}) + INT(${duration[0]}/ 24)`,
                      },
                    });
                  }
                });
              });
            });

            worksheet.getColumn(5).numFmt = '[h]:mm:ss';

            worksheet.getRow(1).font = { bold: true };

            worksheet.views = [
              { state: 'frozen', ySplit: 1 },
            ];

            worksheet.properties.outlineProperties = {
              summaryBelow: false,
              summaryRight: false,
            };

            // save workbook to disk
            workbook.xlsx.writeBuffer({ base64: true }).then((xls64) => {
              // build anchor tag and attach file (works in chrome)
              const a = document.createElement('a');
              const data = new Blob([xls64], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

              const url = URL.createObjectURL(data);
              a.href = url;
              a.download = reportService.generateReportFilename(`${$scope.viewmodel.game.name} Stats`, null, null, 'xlsx');
              document.body.appendChild(a);
              a.click();
              setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              }, 0);
            }).catch((error) => {
              $log.log(error.message);
            });

            $scope.exporting = false;
          });
        },
        exportFlashReport() {
          if (!$scope.viewmodel.history.players.length) {
            return false;
          }

          $scope.exporting = true;

          return instructorService.getSessionGroup(
            $scope.data.gameId,
            $scope.data.sessionGroupId,
          ).then(
            (session_group) => instructorService.getPlayers({ session_group_id: $scope.data.sessionGroupId }).then(
              (players) => {
                players = players.filter((p) => p.high_score !== null);
                const workbook = new ExcelJS.Workbook();
                workbook.creator = 'The Training Arcade';

                /// /////////////
                // Overview
                let worksheet = workbook.addWorksheet('Overview');

                worksheet.getRow(1).values = [
                  'Test Name', 'Session Name', 'Session #', 'Session Date', 'Session Start Time', 'Session End Time',
                ];
                worksheet.columns = [
                  { key: 'test_name', width: 12 },
                  { key: 'session_name', width: 12 },
                  { key: 'session_id', width: 12 },
                  { key: 'date_created', width: 12 },
                  { key: 'time_start', width: 12 },
                  { key: 'time_end', width: 12 },
                ];

                let rowData = {
                  test_name: $scope.viewmodel.game.name,
                  session_name: session_group.name,
                  session_id: session_group.session_group_id,
                  date_created: { formula: `DATEVALUE("${tzService.parseFormatUserDate(session_group.date_created, 'YYYY-MM-DD')}")` },
                  time_start: { formula: `TIMEVALUE("${tzService.parseFormatUserDate(session_group.date_created, 'HH:mm:ss')}")` },
                  time_end: { formula: `TIMEVALUE("${tzService.parseFormatUserDate(session_group.date_ended, 'HH:mm:ss')}")` },
                };

                worksheet.addRow(rowData);

                let values = ['Player'];
                let keys = [
                  { key: 'player', width: 12 },
                ];
                const header = [
                  { header: 'Player', key: 'player', width: 12 },
                ];

                if ($scope.viewmodel.game.registration.required === true) {
                  for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                    if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                      header.push({
                        header: $scope.viewmodel.game.registration.fields[i].label,
                        key: $scope.viewmodel.game.registration.fields[i].key,
                      });
                      values.push($scope.viewmodel.game.registration.fields[i].label);
                      keys.push({ key: $scope.viewmodel.game.registration.fields[i].key, width: 12 });
                    }
                  }

                  for (let i = 0; i < $scope.viewmodel.game.registration.custom_fields.length; i++) {
                    if ($scope.viewmodel.game.registration.custom_fields[i].condition !== null) {
                      header.push({
                        header: $scope.viewmodel.game.registration.custom_fields[i].label,
                        key: $scope.viewmodel.game.registration.custom_fields[i].key,
                      });
                      values.push($scope.viewmodel.game.registration.custom_fields[i].label);
                      keys.push({ key: $scope.viewmodel.game.registration.custom_fields[i].key, width: 12 });
                    }
                  }
                }

                values.push('Total Clues Served');
                values.push('Total Clues Correct');
                values.push('Total Clues Incorrect');
                values.push('Total Clues Not Answered');
                values.push('Total Time to Answer Correct Clues');

                keys.push({ key: 'total_questions', width: 12 });
                keys.push({ key: 'total_correct', width: 12 });
                keys.push({ key: 'total_incorrect', width: 12 });
                keys.push({ key: 'total_missed', width: 12 });
                keys.push({ key: 'total_answer_time', width: 12 });

                // worksheet.columns = header;

                worksheet.getRow(4).values = values;
                worksheet.columns = keys;

                for (let j = 0; j < players.length; j++) {
                  const duration = $filter('formatDuration')(players[j].result.total_correct_time).split(':');

                  rowData = {
                    player: players[j].display_name,
                    total_questions: players[j].result.total,
                    total_correct: players[j].result.total_correct,
                    total_incorrect: players[j].result.total - players[j].result.total_correct,
                    total_missed: 0,
                    total_answer_time: { formula: `TIME(${duration[0]},${duration[1]},${duration[2]}) + INT(${duration[0]}/ 24)` },
                  };

                  if ($scope.viewmodel.game.registration.required === true) {
                    for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
                      if ($scope.viewmodel.game.registration.fields[i].condition !== null) {
                        // eslint-disable-next-line max-len
                        rowData[$scope.viewmodel.game.registration.fields[i].key] = players[j][$scope.viewmodel.game.registration.fields[i].key];
                      }
                    }

                    for (let i = 0; i < $scope.viewmodel.game.registration.custom_fields.length; i++) {
                      if ($scope.viewmodel.game.registration.custom_fields[i].condition !== null) {
                        // eslint-disable-next-line max-len
                        rowData[$scope.viewmodel.game.registration.custom_fields[i].key] = players[j].custom_fields[$scope.viewmodel.game.registration.custom_fields[i].key] ? players[j].custom_fields[$scope.viewmodel.game.registration.custom_fields[i].key].text : null;
                      }
                    }
                  }

                  worksheet.addRow(rowData);
                }

                worksheet.getRow(1).font = { bold: true };
                worksheet.getRow(4).font = { bold: true };

                worksheet.getCell('D2').numFmt = 'm/d/yyyy';
                worksheet.getCell('E2').numFmt = '[h]:mm:ss';
                worksheet.getCell('F2').numFmt = '[h]:mm:ss';
                worksheet.getColumn(keys.length).numFmt = '[h]:mm:ss';

                /* worksheet.views = [
                  {state: 'frozen', ySplit: 1}
                ]; */

                worksheet.properties.outlineProperties = {
                  summaryBelow: false,
                  summaryRight: false,
                };

                /// /////////////
                // Players
                for (let j = 0; j < players.length; j++) {
                  const player = players[j];
                  try {
                    worksheet = workbook.addWorksheet(`${player.first_name} ${player.last_name}`);
                  } catch (err) {
                    worksheet = workbook.addWorksheet(`${player.first_name} ${player.last_name} ${j}`);
                  }

                  // add column headers
                  worksheet.getCell('A1').value = 'Name';
                  worksheet.getCell('A1').font = { bold: true };
                  worksheet.getCell('B1').value = `${player.first_name} ${player.last_name}`;

                  worksheet.getCell('A2').value = 'Session #';
                  worksheet.getCell('A2').font = { bold: true };
                  worksheet.getCell('B2').value = session_group.session_group_id;

                  values = [
                    'Clue #', 'Category', 'Clue Text', 'Correct Answer In Full', 'Acceptable Response(s)',
                    'Test Taker Response', 'Correct', 'Incorrect', 'Original Value', 'Override Date', 'Override By',
                  ];
                  keys = [
                    { key: 'question_num', width: 12 },
                    { key: 'category', width: 12 },
                    { key: 'text', width: 12 },
                    { key: 'exact_answer', width: 12 },
                    { key: 'alt_answers', width: 12 },
                    { key: 'answer_text', width: 12 },
                    { key: 'correct', width: 12 },
                    { key: 'incorrect', width: 12 },
                    { key: 'original_correct', width: 12 },
                    { key: 'date_updated', width: 12 },
                    { key: 'updated_by', width: 12 },
                  ];

                  worksheet.getRow(4).values = values;
                  worksheet.columns = keys;

                  for (let k = 0; k < player.questions.length; k++) {
                    rowData = {
                      question_num: player.questions[k].question_number,
                      category: player.questions[k].question_group ? player.questions[k].question_group.name : null,
                      text: $filter('htmlToPlaintext')(player.questions[k].text),
                      exact_answer: player.questions[k].possible_answers[0].text,
                      // eslint-disable-next-line max-len
                      alt_answers: $filter('getProperty')($filter('filter')(player.questions[k].possible_answers, { match_type: '' }), 'text'),
                      answer_text: $filter('getProperty')(player.questions[k].answers, 'text'),
                      correct: player.questions[k].correct ? 1 : 0,
                      incorrect: player.questions[k].correct ? 0 : 1,
                      // eslint-disable-next-line no-nested-ternary
                      original_correct: player.questions[k].date_updated
                        ? (player.questions[k].original_correct ? 'Correct' : 'Incorrect') : null,
                      date_updated: tzService.parseFormatUserDate(player.questions[k].date_updated, 'YYYY-MM-DD HH:mm:ss'),
                      updated_by: player.questions[k].updated_by,
                    };

                    worksheet.addRow(rowData);
                  }

                  worksheet.getRow(4).font = { bold: true };

                  worksheet.properties.outlineProperties = {
                    summaryBelow: false,
                    summaryRight: false,
                  };
                }

                // save workbook to disk
                workbook.xlsx.writeBuffer({ base64: true }).then((xls64) => {
                  // build anchor tag and attach file (works in chrome)
                  const a = document.createElement('a');
                  const data = new Blob([xls64], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                  const url = URL.createObjectURL(data);
                  a.href = url;
                  a.download = reportService.generateReportFilename(`${$scope.viewmodel.game.name} Stats`, null, null, 'xlsx');
                  document.body.appendChild(a);
                  a.click();
                  setTimeout(() => {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                  }, 0);
                }).catch((error) => {
                  $log.log(error.message);
                });

                $scope.exporting = false;
              },
            ),
          );
        },
      };

      $scope.initialize();
    },
  ]);
